


























import Vue from 'vue'

import { Prefecture, ProductState } from '@/product/types'
import Accordion from '@/common/components/Accordion.vue'
import EstimatedShippingDates from '@/product/components/EstimatedShippingDates.vue'
import EstimatedDeliveryDates from '@/product/components/EstimatedDeliveryDates.vue'
import ShippingNote from '@/product/components/ShippingNote.vue'

export default Vue.extend({
  components: {
    Accordion,
    EstimatedShippingDates,
    EstimatedDeliveryDates,
    ShippingNote
  },
  data(): {
    prefectures: readonly Prefecture[]
    prefectureId: string
  } {
    return {
      prefectures: [],
      prefectureId: ''
    }
  },
  computed: {
    storeSate(): ProductState {
      return this.$store.state
    },
    selectedPrefecture(): Prefecture | undefined {
      const prefecture = this.prefectures.find(item => item.id === this.prefectureId)
      return prefecture
    }
  }
})
